import { type LoggerOptions } from '@vp/ubik-fragment-types'
import { FragmentLogger, type Logger } from '../fragment-logger.js'

import getNewRelicAgent from './new-relic.js'
import { MicroAgentLogger } from './micro-agent-logger.js'
import log from 'loglevel'

export * from '../fragment-logger.js'

export function createLogger(options: LoggerOptions): Logger {
  let agent
  if (options.newrelicLicenseKey != null && options.newrelicApplicationId != null) {
    agent = getNewRelicAgent(options.newrelicApplicationId, options.newrelicLicenseKey)
  }

  const logLevelLogger = log.getLogger(options.serviceName)
  logLevelLogger.setLevel('trace')

  const logger = agent != null ? new MicroAgentLogger(logLevelLogger, agent, options.microAgentLogLevel) : new FragmentLogger(logLevelLogger)

  logger.setLoggerName(options.serviceName)
  if (options.logLevel != null) {
    logger.setLoggerLevel(options.logLevel)
  }

  return logger
}
